import {
    EventCollection,
    Flocks,
    Footer,
    VenueLogoList,
} from '@beat-venues/ui/react';
import { useQuery } from '@tanstack/react-query';
import { useContext, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useStoryStore } from '../../states/stroy-state';
import { UserContext } from '../../context';

type LayoutWrapperProps = {
    children: ReactElement | ReactElement[];
};

const LayoutWrapper = ({ children }: LayoutWrapperProps): ReactElement => {
    const { stories, setStories } = useStoryStore();
    const { t, i18n } = useTranslation();
    const { user } = useContext(UserContext);

    useQuery({
        queryKey: ['events-story', i18n.language],
        queryFn: async () => {
            const result = await fetch(
                `/api/events/story?lang=${i18n.language}`
            ).then((res) => {
                if (res.ok) {
                    return res.json();
                } else return [];
            });
            setStories(result);
        },
    });

    const { data: footerData } = useQuery({
        queryKey: ['footer', i18n.language],
        queryFn: () =>
            fetch('/api/contentful/footer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    locale: i18n.language,
                    tag: 'channel-my-beat',
                }),
            }).then((res) => res.json()),
        enabled: !!user?.sfContactId,
    });

    return (
        <div>
            <main data-portal-root="modal" role="main">
                <Flocks venue="beat">
                    {children}
                    {stories && stories.length > 0 && (
                        <EventCollection
                            className="mt-24"
                            events={stories}
                            layout="mainBrand"
                            title={t('storyBanner.title') ?? undefined}
                        />
                    )}
                </Flocks>
                <VenueLogoList className="-mt-12" includeBeat={false} />
            </main>
            {footerData && (
                <Footer
                    footerCopy={footerData.footerCopy}
                    legalLinks={footerData.legalLinks}
                    links={footerData.navigationItems}
                    partners={footerData.partners}
                    socialLinks={footerData.socialLinks}
                    venueId="beat"
                />
            )}
        </div>
    );
};

export { LayoutWrapper };
